const plugin = {
    install() {
        const user = _.clone(window.User)
        window.User = null

        Vue.prototype.$user = user
    }
}

Vue.use(plugin)



// WEBPACK FOOTER //
// ./resources/assets/js/user.js